import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";



const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));




export default function ArtigoListar() {
    const classes = useStyles();

    const [artigos, setArtigos] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [inativos, setInativos] = React.useState(false);
    const [lista, setLista] = useState([]);


    useEffect(()=>{
        setLoading(true)
        if(inativos===true){
            api.get('/item/all').then(res=>{
                if(res.data.code===0){
                    setArtigos(res.data.data)
                    setLista(res.data.data)
                }
                setLoading(false)
            })
        }else {
            api.get('/item').then(res=>{
                if(res.data.code===0){
                    setArtigos(res.data.data)
                    setLista(res.data.data)
                }
                setLoading(false)
            })
        }
    }, [inativos])

    const columns = [
        {
            name: "Codigo",
            selector: "itemCode",
            sortable: true
        },
        {
            name: "Descricão",
            selector: "descricao",
            sortable: true
        },  {
            name: "Familia",
            selector: "familia",
            sortable: true
        },
        {
            name:"",
            cell:row=><Link to={"/artigos/" + row.id}><Button variant={"contained"} color={"primary"}>Ficha</Button></Link>
        },
        {
            name:"",
            cell:row=><Link to={"/artigos/editar/" + row.id}><Button variant={"contained"} color={"primary"}>Editar</Button></Link>
        }
    ];

    function pesquisa(e) {
        // eslint-disable-next-line array-callback-return
        let temp =lista.filter(value => {
            if((value.itemCode.toLowerCase().includes(e.target.value.toLowerCase()))||(value.descricao.toLowerCase().includes(e.target.value.toLowerCase())) || (value.familia.toLowerCase().includes(e.target.value.toLowerCase()))){
                return value;
            }
        })
        setArtigos(temp)
    }

    return (
        <Container component="main" maxWidth="md">
            <TextField label="Pesquisa" onChange={pesquisa}/>
            <FormControlLabel
                control={
                    <Switch
                        checked={inativos}
                        onChange={()=>setInativos(!inativos)}
                        name="checkedB"
                        color="primary"
                    />
                }
                label="Mostrar descontinuados"
            />
            <div className={classes.paper}>
                <DataTable
                    title="Artigos"
                    columns={columns}
                    data={artigos}
                    sortIcon={<SortIcon />}
                    pagination
                    //selectableRows
                    selectableRowsComponent={Checkbox}
                    contextMessage={{
                        singular: 'artigo',
                        plural: 'artigos',
                        message: 'selecionada\\s' }}
                    noDataComponent={"Não foi encontradas artigos"}
                    progressPending={loading}
                    progressComponent={<CircularProgress />}
                    paginationComponentOptions={{
                        rowsPerPageText: 'Linhas por pagina:',
                        rangeSeparatorText: 'de',
                        noRowsPerPage: false,
                        selectAllRowsItem: false,
                        selectAllRowsItemText: 'Todas'
                    }}
                />
            </div>
        </Container>
    );
}
